// extracted by mini-css-extract-plugin
export default {"planContainer":"SuscriptionPlanBanner_planContainer__UCXEM","priceContainer":"SuscriptionPlanBanner_priceContainer__SYKr5","light":"SuscriptionPlanBanner_light__EDM5n"};